
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AdminSearch } from "./shared/AdminSearch";
import { AdminFilters } from "./shared/AdminFilters";
import { AdminPagination } from "./shared/AdminPagination";
import { EpisodesCategoriesSection } from "./categories/EpisodesCategoriesSection";
import { ActivitiesCategoriesSection } from "./categories/ActivitiesCategoriesSection";

export const CategoriesManager = () => {
  const [activeTab, setActiveTab] = useState("episodes");
  
  return (
    <div className="admin-container space-y-4 md:space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl md:text-2xl font-bold">Categories Management</h2>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4 md:space-y-6">
        <TabsList className="grid w-full grid-cols-2 h-auto">
          <TabsTrigger value="episodes" className="text-sm md:text-base py-2">
            Episodes Categories
          </TabsTrigger>
          <TabsTrigger value="activities" className="text-sm md:text-base py-2">
            Activities Categories
          </TabsTrigger>
        </TabsList>

        <TabsContent value="episodes" className="admin-container">
          <EpisodesCategoriesSection />
        </TabsContent>

        <TabsContent value="activities" className="admin-container">
          <ActivitiesCategoriesSection />
        </TabsContent>
      </Tabs>
    </div>
  );
};
